<h2 *ngIf="!hideHeader">{{ headerText }}</h2>
<div>
  <h3>{{ offerText }}</h3>
  <p>
    <small>{{ offerPromoText }}</small>
  </p>
</div>
<button mat-raised-button (click)="openContactForm()">{{ buttonText }}</button>
